import React from 'react';
import i18n, { getI18nLang, setI18nLang, i18nRaw } from './index.mjs';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function _callI18n(func) {
    return function (lang, keyset, key, options) {
        var prevLang = getI18nLang();
        setI18nLang(lang);
        var result = func(keyset)(key, options);
        setI18nLang(prevLang);
        return result;
    };
}
var _i18nReact = _callI18n(i18n);
var _i18nRawReact = _callI18n(i18nRaw);
var Lang = React.createContext({ lang: 'ru' });
var useI18N = function (keyset, forceLang) {
    var contextLang = React.useContext(Lang).lang;
    var lang = forceLang || contextLang;
    return React.useCallback(function (key, options) { return _i18nReact(lang, keyset, key, options); }, [lang, keyset]);
};
var useI18NRaw = function (keyset, forceLang) {
    var contextLang = React.useContext(Lang).lang;
    var lang = forceLang || contextLang;
    return React.useCallback(function (key, options) {
        return (_i18nRawReact(lang, keyset, key, options)
            .map(function (element, i) { return React.createElement(React.Fragment, { key: i }, element); }));
    }, [lang, keyset]);
};
var ComponentI18n = (function (_super) {
    __extends(ComponentI18n, _super);
    function ComponentI18n() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i18n = function (keyset) {
            return function (key, options) { return _i18nReact(_this.getLang(), keyset, key, options); };
        };
        _this.i18nRaw = function (keyset) {
            return function (key, options) { return _i18nRawReact(_this.getLang(), keyset, key, options); };
        };
        _this.getLang = function () {
            return _this.context.lang || _this.props.lang;
        };
        return _this;
    }
    ComponentI18n.contextType = Lang;
    return ComponentI18n;
}(React.Component));
var PureComponentI18n = (function (_super) {
    __extends(PureComponentI18n, _super);
    function PureComponentI18n() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i18n = function (keyset) {
            return function (key, options) { return _i18nReact(_this.getLang(), keyset, key, options); };
        };
        _this.i18nRaw = function (keyset) {
            return function (key, options) { return _i18nRawReact(_this.getLang(), keyset, key, options); };
        };
        _this.getLang = function () {
            return _this.context.lang || _this.props.lang;
        };
        return _this;
    }
    PureComponentI18n.contextType = Lang;
    return PureComponentI18n;
}(React.PureComponent));

export { ComponentI18n, Lang, PureComponentI18n, useI18N, useI18NRaw };
